import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-tree-update',
  templateUrl: './payment-tree-update.component.html',
  styleUrls: ['./payment-tree-update.component.scss']
})
export class PaymentTreeUpdateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
